import PopoverContext, {
  PopoverContextProvider as PopoverProvider,
} from './PopoverContext';

const PopoverContextProvider = PopoverProvider;

export { PopoverContext as default, PopoverContextProvider };
